import React from 'react';
import { Query } from 'react-apollo';
import { GET_PROFILE } from 'graphql/lc/profile';
import Spin from "components/common/Spin";
import HighSchoolForm from "./HighSchoolForm";

const HighSchool = ({ user }) => {

  return (
    <Query query={GET_PROFILE} variables={{ id: user.id }}>
      {({ data, loading }) => {
        if (!data) return <Spin spinning />;
        const profile = data.lc_profile[0];
        const props = {
          highschool_info: profile.highschool_info || {},
          user
        };
        return (
          <Spin spinning={loading}>
            <HighSchoolForm {...props} />
          </Spin>
        )
      }}
    </Query>
  );
};

export default HighSchool;

